<template>
    <span
        class="sc-icon"
        :class="{ 'sc-icon--outlined': !filled }"
        aria-hidden="true"
        :style="{
            fontFamily: 'var(--font-icon)',
            fontSize: size + 'px',
            width: size + 'px',
            height: size + 'px',
            color: color || 'inherit',
        }"
    >{{ name }}</span>
</template>

<script>
export default {
    name: 'DsIcon',
    props: {
        name: { type: String, required: true },
        size: { type: [Number, String], default: 20 },
        filled: { type: Boolean, default: true },
        color: { type: String, default: null },
    },
}
</script>
